module.exports = __webpack_public_path__ + "img/alert_error_icon.4d2b038c.svg";